import { API_HEAD } from '@/lib/apiConfig';

export type BookingStatus = 'processing' | 'completed' | 'cancelled';

export interface Booking {
  id: number;
  fullName?: string;
  phone: string;
  email?: string;
  gender?: string;
  occupation?: string;
  dateOfBirth?: string;
  service?: string;
  note?: string;
  status: BookingStatus;
  createdAt: string;
  updatedAt: string;
}

export interface BookingsResponse {
  success: boolean;
  data: Booking[];
}

export interface BookingResponse {
  success: boolean;
  data: Booking;
}

class BookingService {
  private async publicRequest<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const response = await fetch(`${API_HEAD}bookings${endpoint}`, {
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
      ...options,
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || `HTTP ${response.status}`);
    }
    return response.json();
  }
  private getHeaders(): HeadersInit {
    const token = typeof window !== 'undefined' ? localStorage.getItem('adminToken') : null;
    return {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const response = await fetch(`${API_HEAD}bookings${endpoint}`, {
      headers: { ...this.getHeaders(), ...(options.headers || {}) },
      ...options,
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || `HTTP ${response.status}`);
    }
    return response.json();
  }

  list(): Promise<BookingsResponse> {
    return this.request<BookingsResponse>('');
  }

  get(id: number | string): Promise<BookingResponse> {
    return this.request<BookingResponse>(`/${id}`);
  }

  updateStatus(id: number | string, status: BookingStatus): Promise<BookingResponse> {
    return this.request<BookingResponse>(`/${id}`, {
      method: 'PUT',
      body: JSON.stringify({ status }),
    });
  }

  // Public create booking (no auth)
  createPublic(data: Pick<Booking, 'fullName' | 'phone' | 'email' | 'service'> & { note?: string }): Promise<{ success: boolean; message?: string; data?: Booking; }> {
    return this.publicRequest<{ success: boolean; message?: string; data?: Booking; }>(``, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}

const bookingService = new BookingService();
export default bookingService;


